import fetcher from 'modules/fetcher'

export const fetchAll = (page) => {
  const query = page ? { page } : undefined
  return fetcher('/sync/messages', { query })
}

export const fetchMessage = (id) => {
  return fetcher(`/sync/messages/${id}`)
}

export const markRead = (ids) => {
  return fetcher('/sync/messages/mark_read', {
    method: 'POST',
    body: JSON.stringify({ ids })
  })
}

export const markUnread = (ids) => {
  return fetcher('/sync/messages/mark_unread', {
    method: 'POST',
    body: JSON.stringify({ ids })
  })
}

export const markArchived = (ids) => {
  return fetcher('/sync/messages/archive', {
    method: 'POST',
    body: JSON.stringify({ ids })
  })
}

export const ignorePerson = (email) => {
  return fetcher('/sync/messages/ignore_person', {
    method: 'POST',
    body: JSON.stringify({ email })
  })
}

export const unIgnoreEmail = (email) => {
  return fetcher('/sync/messages/unignore_email', {
    method: 'POST',
    body: JSON.stringify({ email })
  })
}

export const syncedUser = () => {
  return fetcher('/sync/messages/synced_user')
}

export const stop = () => {
  return fetcher('/sync/messages/stop', { method: 'POST' })
}

export const assignDeal = (noteId, dealId) => {
  return fetcher(`/connect/notes/${noteId}`, {
    method: 'PUT',
    body: JSON.stringify({ deal_id: dealId })
  })
}
